import React from 'react';

import { INLINES } from '@contentful/rich-text-types';
import { Link } from 'gatsby';

const richTextOptions = {
  renderNode: {
    [INLINES.HYPERLINK]: (node, children) => {
      const {
        data: { uri = '' },
      } = node;
      const isLocalDomain = new RegExp('^(https?://)?([a-z]+-)?miwom.wom.cl');
      if (/^\//.test(uri) || isLocalDomain.test(uri)) {
        return <Link to={uri}>{children}</Link>;
      }
      return (
        <a href={uri} target="_blank" rel="noreferrer">
          {children}
        </a>
      );
    },
  },
};

export default {
  richTextOptions,
};
